module.exports = __webpack_public_path__ + "static/media/hero.b882d4ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/long-road-student-centre/hero.jpg
// module id = 59
// module chunks = 0